module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-164ae53e.png";